module.exports = __webpack_public_path__ + "static/media/occasion-valentines.7c3717fb.png";